import React from 'react';
const validate = function(WrappedComponent,form) {
    return class HOC extends React.Component {
        onChange = (e)=>{
            this.props.onChange(e);
            form.setFields({
                [this.props.id]:{
                    value:e.target.value,
                    errors:null
                }
            });
        }
        render() {
            return <WrappedComponent {...this.props} onChange={this.onChange}/>;
        };
    };
};
export default validate;



// WEBPACK FOOTER //
// ./src/components/InputValidate/index.js